import { Injectable } from '@angular/core';
import { toast } from 'ngx-sonner';

const TOAST_ID = 'app-action';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  success(message: string): void {
    toast.success(message, { id: TOAST_ID, duration: 3500 });
  }

  error(message: string): void {
    toast.error(message, { id: TOAST_ID, duration: 6000, important: true });
  }
}
